<ion-toolbar color="eprintprimary" mode="ios" class="ion-no-border">
  <ion-buttons data-cy="menuBtn" class="theme-secondary" slot="start">
    <ng-content select="[start]"></ng-content>
  </ion-buttons>
  <ion-title class="ion-text-center" *ngIf="pageName && !noTitle" role="heading" aria-level="1"><ion-text class="ion-text-wrap">{{ pageName }}</ion-text></ion-title>
  <ion-title *ngIf="!pageName && noTitle">
    <div class="header-logo">
      <ion-icon class="theme-secondary img" slot="icon-only" [src]="imgConstants.EPRINT_LOGO" aria-label="logo"></ion-icon>
    </div>
  </ion-title>
  <ion-buttons slot="end">
    <ng-content select="[end]"></ng-content>
  </ion-buttons>
</ion-toolbar>